import React, { Component } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { translate } from "react-i18next"
import CustomReportReviewQuestion from "./CustomReportReviewQuestion"
import uniqid from "uniqid"

const GroupTitle = styled.span`
  font-weight: 500;
  margin-left: 25px;
`

const QuestionListItem = styled.div`
  padding: 2px 0;
  margin: 0 10px 0 20px;
  border-bottom: dotted 1px #ccc;
  font-size: 0.9rem;
`
class CustomReportReviewQuestionGroup extends Component {
  state = {
    checked: false
  }
  componentDidUpdate(prevProps) {
    if (this.props.checked !== prevProps.checked) {
      this.setState(prevState => ({ checked: this.props.checked }))
    }
  }
  handleCheckboxClick = (e) => {
    if (e.target.value === "false"){
      this.setState(prevState => ({ checked: true }))

      this.props.addSelectedQuestions(this.props.groupQuestions);
    } else {
      this.setState(prevState => ({ checked: false }))

      this.props.removeSelectedQuestions(this.props.groupQuestions);
    }
  }

  render() {
    const { groupQuestions, groupCount, t } = this.props
    const translatedText =
      groupQuestions.length > 0 ? t(groupQuestions[0].groupNameTranslationIdentifier) : ""

    // Creating a unique identitfier for the checkbox to make sure we don't have clashes.
    const checkboxId = `chk_${uniqid()}_${groupQuestions[0].groupNameTranslationIdentifier}`
    return (
      <div>
        {groupCount > 1 &&
          translatedText &&
          translatedText.length > 0 && (
          <div className="row" style={{marginRight: "0px", borderBottom: "dotted 1px #ccc"}}>
            <div className="col-lg-11 col-md-11">
              <GroupTitle>{translatedText}</GroupTitle>
            </div>
            <div className="col-lg-1 col-md-1">
                <input
                  type="checkbox"
                  id={checkboxId}
                  checked={this.state.checked}
                  className="filled-in"
                  onChange={this.handleCheckboxClick}
                  value={this.state.checked}
                />
                <label htmlFor={checkboxId}>&nbsp;</label>
            </div>
          </div>
        )}
        {groupQuestions.map((q) => {
          return (
            <QuestionListItem key={q.questionId}>
              <CustomReportReviewQuestion question={q}       
                  addSelectedQuestions={this.props.addSelectedQuestions}
                  removeSelectedQuestions={this.props.removeSelectedQuestions}/>
            </QuestionListItem>
          )
        })}
      </div>
    )
  }
}

CustomReportReviewQuestionGroup.propTypes = {
  groupQuestions: PropTypes.array.isRequired,
  groupCount: PropTypes.number.isRequired,
  questionSelected: PropTypes.func.isRequired,
  addSelectedQuestions: PropTypes.func,
  removeSelectedQuestions: PropTypes.func,
  checked: PropTypes.bool.isRequired
}
export default translate()(CustomReportReviewQuestionGroup)



// WEBPACK FOOTER //
// ./src/components/custom-report/Modals/QuestionSelection/CustomReportReviewQuestionGroup.jsx